import * as auth from './auth'
import * as user from './user'
import * as courses from './courses'
import * as banners from './banners'
import * as player from './player'

export default { auth, user, courses, banners, player }
